'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var RuleCustomController = function RuleCustomController($scope, conditionsAndActionsService, saveRuleService, StrategyCondition, Rule, StrategyConstants, elementServiceProvider, commentsService, userSecureService, featureToggleService, validation, commonUiConstants, xtFormValidationService) {
  var NEW_ALERT_RULE = 'New Custom Alert Rule';
  var NEW_RULE = 'New Custom Rule';
  var OPERAND_DATA_OVER_THRESHOLD_ERROR_MESSAGE = '';
  var marketPrivilege = userSecureService.hasAuthorization('market-analysis', 'write');
  var flightPrivilege = userSecureService.hasAuthorization('flight-analysis', 'write');
  var formulaeMaster = [];
  function secureMarketFlightPrivilege() {
    var levels = [];
    if (marketPrivilege && !flightPrivilege) {
      _.filter(conditionsAndActionsService.getLevels($scope.rule.type), function (level) {
        if (level.domain === 'ServiceClassPOS' || level.domain === 'MarketDemandClassGroup') {
          return levels.push(level);
        }
      });
    } else if (!marketPrivilege && flightPrivilege) {
      _.filter(conditionsAndActionsService.getLevels($scope.rule.type), function (level) {
        if (level.domain !== 'ServiceClassPOS' && level.domain !== 'MarketDemandClassGroup') {
          return levels.push(level);
        }
      });
    } else {
      levels = conditionsAndActionsService.getLevels($scope.rule.type);
    }
    if (featureToggleService.isDisabled('SPOS')) {
      _.forEach(levels, function (level) {
        if (_.includes(level.label, 'POS')) {
          level.label = _.trimEnd(_.replace(level.label, 'POS', ''));
        }
      });
    }
    return levels;
  }
  $scope.ruleStatusOptions = StrategyConstants.DROP_DOWN_DATA.RULE_STATUS;
  $scope.levelOptions = secureMarketFlightPrivilege();
  $scope.isSummaryVisible = false;
  $scope.summaryMessage = StrategyConstants.ERROR_MESSAGES.MULTIPLE;
  $scope.commentsOpened = false;
  $scope.RULE_NAME_PATTERN = commonUiConstants.ALPHA_NUMERIC_WITH_SOME_EXTRA_CHARS;
  $scope.ruleNameMsg = 'Rule name contains invalid characters. Only alphanumeric characters and -, _, <, >, = are allowed.';
  var defaultStrategyDomainLevel = conditionsAndActionsService.getDefaultStrategyDomainLevel();
  $scope.defaultStrategyDomainLevel = conditionsAndActionsService.getLevelByDomain(defaultStrategyDomainLevel);
  function setIsFlowTypeSelectable(level) {
    var isFlowTypeSelectable = conditionsAndActionsService.getLevelByDomain(level.domain).isFlowTypeSelectable;
    if (isFlowTypeSelectable) {
      level.isFlowTypeSelectable = isFlowTypeSelectable;
    }
  }
  function fetchFormulaeMaster() {
    var formulae = [];
    var fieldPrefix = 'custom';
    var formulaNameList = [];
    _.forEach($scope.conditionCategories, function (category) {
      _.filter(category, function () {
        _.forEach(category.criteria, function (criteria) {
          if (criteria.field.split('.')[0] === fieldPrefix && formulaNameList.indexOf(criteria.field.split('.')[1]) == -1) {
            var formula = {};
            formulaNameList.push(criteria.field.split('.')[1]);
            formula.name = criteria.field.split('.')[1];
            formula.formula = criteria.formula;
            formulae.push(formula);
          }
        });
      });
    });
    return formulae;
  }
  function fetchRuleFormulae(formulaeMaster) {
    var formulae = [];
    var fieldPrefix = 'custom';
    _.forEach($scope.rule.primaryCriteria, function (criteria) {
      if (criteria.field.split('.')[0] === fieldPrefix) {
        _.forEach(formulaeMaster, function (formulaObj) {
          if (formulaObj.name === criteria.field.split('.')[1]) {
            formulae.push(formulaObj);
          }
        });
      }
    });
    return formulae;
  }
  function fetchLinkFormulae(formulaeMaster) {
    var formulae = [];
    var fieldPrefix = 'custom';
    _.forEach($scope.rule.linkCriteria, function (criteria) {
      if (criteria.field.split('.')[0] === fieldPrefix) {
        _.forEach(formulaeMaster, function (formulaObj) {
          if (formulaObj.name === criteria.field.split('.')[1]) {
            formulae.push(formulaObj);
          }
        });
      }
    });
    return formulae;
  }

  //set default when secure flight or market
  if (marketPrivilege && !flightPrivilege) {
    $scope.rule.primaryCriteriaLevel = conditionsAndActionsService.getLevelByDomain('ServiceClassPOS');
  } else if ($scope.rule.primaryCriteriaLevel) {
    var primaryLevel = $scope.rule.primaryCriteriaLevel;
    setIsFlowTypeSelectable(primaryLevel);
  }
  if ($scope.rule.linkCriteriaLevel) {
    var linkLevel = $scope.rule.linkCriteriaLevel;
    setIsFlowTypeSelectable(linkLevel);
  }
  $scope.primaryCriteriaElementService = elementServiceProvider.getInstance({
    preAddingNewElementHook: function preAddingNewElementHook() {
      setActiveElementService($scope.primaryCriteriaElementService);
      return true;
    },
    createNewElement: function createNewElement() {
      return new StrategyCondition({});
    },
    getCollection: function getCollection() {
      return $scope.rule && $scope.rule.primaryCriteria;
    },
    getSelectedRowType: function getSelectedRowType() {
      return StrategyConstants.CONDITION;
    },
    getCollectionDomain: function getCollectionDomain() {
      return $scope.rule.primaryCriteriaLevel.domain;
    },
    getServiceType: function getServiceType() {
      return 'primaryCriteria';
    },
    isDuplicable: function isDuplicable() {
      return true;
    },
    createCopyOf: function createCopyOf(element) {
      if (element instanceof StrategyCondition) {
        return element.createCopy();
      }
      return null;
    }
  });
  $scope.ruleKeyForComments = 'technicalId';
  function determinePanelTitle() {
    if ($scope.rule.old) {
      return $scope.rule.name;
    }
    return $scope.rule.type === StrategyConstants.PANEL_TYPE.ALERTS ? NEW_ALERT_RULE : NEW_RULE;
  }
  $scope.panelTitle = determinePanelTitle();
  $scope.dialogMessageType = null;
  $scope.linkCriteriaCheckboxDisabled = true;
  function resetAllCriteriaRows() {
    if ($scope.rule.linkCriteriaEnabled) {
      $scope.linkCriteriaElementService.resetCollection();
    }
    $scope.primaryCriteriaElementService.resetCollection();
    var activeElementServiceType = activeElementService.getServiceType();
    if (activeElementServiceType === 'primaryCriteria' && $scope.rule.linkCriteriaEnabled) {
      $scope.linkCriteriaElementService.clearSelection();
    } else if (activeElementServiceType === 'linkCriteria') {
      $scope.primaryCriteriaElementService.clearSelection();
    }
  }
  function updateStrategiesGrid() {
    $scope.$broadcast('ruleCustom:updateStrategiesGrid');
  }
  $scope.switchFlowType = function () {
    resetAllCriteriaRows();
    updateConditionCategories(activeElementService.getCollectionDomain());
    updateStrategiesGrid();
  };
  $scope.cancelFlowTypeChange = function () {
    $scope.rule.flowType = StrategyConstants.FlowType.find(function (val) {
      return val !== $scope.rule.flowType;
    });
  };
  function handleFlowTypeChange(newType, oldType) {
    if ($scope.rule.isEditing) {
      return;
    }
    if (oldType !== undefined && newType !== oldType) {
      if (conditionsProvided() || linkedConditionsProvided()) {
        $scope.dialogMessageType = StrategyConstants.CONFIRMATION_MESSAGES.FLOW_TYPE.CONDITIONS_CUSTOM;
        $scope.showConfirmationDialog();
      } else if (hasAppliedStrategiesWithChangedFlowType()) {
        $scope.dialogMessageType = StrategyConstants.CONFIRMATION_MESSAGES.FLOW_TYPE.STRATEGIES_SELECTED;
        $scope.showConfirmationDialog();
      } else {
        $scope.switchFlowType();
      }
    } else {
      updateStrategiesGrid();
    }
  }
  if (featureToggleService.isEnabled('MAPPED_MODE')) {
    $scope.$watch('rule.flowType', handleFlowTypeChange);
  }

  // used by the accordion to add a new condition to primary or link criteria
  var activeElementService = $scope.primaryCriteriaElementService;
  function setActiveElementService(elementService) {
    if (activeElementService !== elementService) {
      activeElementService.clearSelection();
    }
    activeElementService = elementService;
  }
  $scope.isRowSelectedPrimaryCriteria = $scope.primaryCriteriaElementService.isElementSelected;
  $scope.conditionsAccordionSelect = function (conditionCategory, conditionCriteria) {
    activeElementService.insertElement(new StrategyCondition({
      metaCategory: conditionCriteria.metaCategory,
      category: conditionCategory.categoryName,
      criterion: conditionCriteria.criteriaName,
      field: conditionCriteria.field,
      operator: conditionCriteria.operators[0].operator,
      precision: conditionCriteria.operators[0].precision,
      isFieldValueRequired: !_.isUndefined(conditionCategory.isFieldValueRequired) ? conditionCategory.isFieldValueRequired : true
    }));
  };
  function resetStrategyGroup(elementService) {
    elementService.resetCollection();
    setActiveElementService(elementService);
  }
  function updateConditionCategories(domain) {
    var condition = conditionsAndActionsService.getConditionByDomain(domain, $scope.rule.type, $scope.rule.flowType);
    $scope.conditionCategories = condition.categories;
  }
  $scope.setDefaultFlowType = function () {
    if (featureToggleService.isEnabled('MAPPED_MODE')) {
      if (hasRuleFlowTypeSelectableLevels()) {
        $scope.rule.flowType = $scope.rule.flowType || defaultFlowType();
      } else {
        $scope.rule.flowType = undefined;
      }
    }
  };
  function defaultFlowType() {
    var domain = _.get($scope, 'entity.primaryCriteriaLevel.domain');
    return _.get(StrategyConstants.DefaultFlowType, domain, StrategyConstants.DefaultFlowType["default"]);
  }
  $scope.onPrimaryCriteriaSelectedLevelChanged = function (newCriteria, oldCriteria) {
    if (!$scope.rule.primaryCriteriaLevel.fromEdit && newCriteria.domain !== oldCriteria.domain) {
      resetStrategyGroup($scope.primaryCriteriaElementService);
      $scope.setDefaultFlowType();
    }
    updateConditionCategories($scope.rule.primaryCriteriaLevel.domain);
    $scope.rule.primaryCriteriaLevel.fromEdit = false;
  };
  $scope.changeSelectedRowPrimaryCriteria = function (elem) {
    $scope.primaryCriteriaElementService.selectElement(elem);
    updateConditionCategories($scope.rule.primaryCriteriaLevel.domain);
    setActiveElementService($scope.primaryCriteriaElementService);
  };
  $scope.linkCriteriaElementService = elementServiceProvider.getInstance({
    preAddingNewElementHook: function preAddingNewElementHook() {
      setActiveElementService($scope.linkCriteriaElementService);
      return true;
    },
    createNewElement: function createNewElement() {
      return new StrategyCondition({});
    },
    getCollection: function getCollection() {
      return $scope.rule && $scope.rule.linkCriteria;
    },
    getCollectionDomain: function getCollectionDomain() {
      return $scope.rule.linkCriteriaLevel.domain;
    },
    getServiceType: function getServiceType() {
      return 'linkCriteria';
    },
    isDuplicable: function isDuplicable() {
      return true;
    },
    createCopyOf: function createCopyOf(element) {
      if (element instanceof StrategyCondition) {
        return element.createCopy();
      }
      return null;
    }
  });
  $scope.isRowSelectedLinkCriteria = $scope.linkCriteriaElementService.isElementSelected;
  $scope.onLinkCriteriaSelectedLevelChanged = function () {
    if ($scope.rule.linkCriteriaEnabled) {
      if (!$scope.rule.linkCriteriaLevel.fromEdit) {
        $scope.setDefaultFlowType();
      }
      $scope.resetAndUpdateConditionCategories(!$scope.rule.linkCriteriaLevel.fromEdit);
      $scope.rule.linkCriteriaLevel.fromEdit = false;
    }
  };
  $scope.resetAndUpdateConditionCategories = function (reset) {
    if (reset) {
      resetStrategyGroup($scope.linkCriteriaElementService);
    }
    updateConditionCategories($scope.rule.linkCriteriaLevel.domain);
  };
  $scope.onLinkCriteriaEnabledChanged = function (newVal, oldVal) {
    if ($scope.rule.linkCriteriaEnabled) {
      $scope.resetAndUpdateConditionCategories(!$scope.rule.linkCriteriaEnabledFromEdit);
    } else {
      $scope.rule.linkCriteria = [];
      $scope.rule.linkCriteriaLevel = $scope.defaultStrategyDomainLevel;
      setActiveElementService($scope.primaryCriteriaElementService);
      activeElementService.selectFirstElement();
      updateConditionCategories($scope.rule.primaryCriteriaLevel.domain);
      if (!(newVal === oldVal && newVal === false && $scope.rule.old)) {
        $scope.setDefaultFlowType();
      }
    }
    $scope.rule.linkCriteriaEnabledFromEdit = false;
  };
  $scope.changeSelectedRowLinkCriteria = function (elem) {
    $scope.linkCriteriaElementService.selectElement(elem);
    updateConditionCategories($scope.rule.linkCriteriaLevel.domain);
    setActiveElementService($scope.linkCriteriaElementService);
  };
  function closePanel() {
    $scope.hideConfirmationDialog();
    $scope.xtForm.reset();
    $scope.hideSummary();
    $scope.closePanelHandler();
    $scope.$emit('rules:toggleReadOnlyPanelVisibility');
    $scope.commentsExist = false;
    $scope.commentsOpened = false;
    $scope.strategiesPanelVisible = false;
  }
  function hasRuleFlowTypeSelectableLevels() {
    return $scope.rule.primaryCriteriaLevel.isFlowTypeSelectable || $scope.rule.linkCriteriaEnabled && $scope.rule.linkCriteriaLevel.isFlowTypeSelectable;
  }
  function resetFlowTypeIfNotApplicable() {
    if (!$scope.rule.primaryCriteriaLevel.isFlowTypeSelectable && !($scope.rule.linkCriteriaEnabled && $scope.rule.linkCriteriaLevel.isFlowTypeSelectable && linkedConditionsProvided())) {
      $scope.rule.flowType = undefined;
    }
  }
  $scope.saveRule = function () {
    var ruleNote = $scope.rule.notes;
    $scope.rule.notes = undefined;
    formulaeMaster = fetchFormulaeMaster();
    $scope.rule.ruleFormulae = fetchRuleFormulae(formulaeMaster);
    $scope.rule.linkFormulae = fetchLinkFormulae(formulaeMaster);
    resetFlowTypeIfNotApplicable();
    saveRuleService.saveRule($scope.rule).then(function (response) {
      $scope.$emit('rules:dataAndSelectionChanged', {
        name: $scope.rule.name,
        technicalId: response.technicalId
      });
      if (ruleNote) {
        ruleNote = ruleNote.substring(0, 500);
        commentsService.save({
          technicalId: response.technicalId
        }, $scope.ruleKeyForComments, ruleNote, $scope.rule.primaryCriteriaLevel.domain);
      }
      closePanel();
      toastr.success('Successfully saved changes.');
    }, function (reason) {
      $scope.isSummaryVisible = true;
      var reasonStr = reason.data ? ' (' + reason.data.message + ')' : '';
      $scope.summaryMessage = StrategyConstants.ERROR_MESSAGES.SAVING + reasonStr;
    });
  };
  function hasIncompleteLinkConditions() {
    return _.find($scope.rule.linkCriteria, validation.isCriteriaIncomplete);
  }
  function hasOperandDataQuantityOverThreshold() {
    var criteriaOverThreshold = validation.filterCriteriaOverThreshold($scope.rule.primaryCriteria);
    if ($scope.rule.linkCriteriaEnabled) {
      criteriaOverThreshold = criteriaOverThreshold.concat(validation.filterCriteriaOverThreshold($scope.rule.linkCriteria));
    }
    if (criteriaOverThreshold.length > 0) {
      var criteriaNames = validation.getCriteriaNamesForMessage(criteriaOverThreshold);
      OPERAND_DATA_OVER_THRESHOLD_ERROR_MESSAGE = StrategyConstants.ERROR_MESSAGES.OPERAND_DATA_OVER_THRESHOLD + criteriaNames;
      return true;
    }
    return false;
  }
  function conditionsProvided() {
    return !_.every($scope.rule.primaryCriteria, validation.isCriteriaEmpty);
  }
  function linkedConditionsProvided() {
    return $scope.rule.linkCriteriaEnabled && !_.every($scope.rule.linkCriteria, validation.isCriteriaEmpty);
  }
  function hasAppliedStrategies() {
    return $scope.rule.appliedStrategies && $scope.rule.appliedStrategies.length > 0;
  }
  function isStrategyIncompatibleFlowType(strategy) {
    return strategy.flowType !== undefined && strategy.flowType !== $scope.rule.flowType;
  }
  function hasAppliedStrategiesWithChangedFlowType() {
    if (hasAppliedStrategies() && $scope.rule.flowType !== undefined) {
      return _.find($scope.rule.appliedStrategies, isStrategyIncompatibleFlowType);
    }
    return false;
  }
  $scope.focusError = function () {
    if ($scope.focusErrorMsg) {
      $scope.focusErrorMsg();
    }
  };
  $scope.saveButtonHandler = function () {
    $scope.summaryMessage = null;
    $scope.isSummaryVisible = false;
    var duplicated;
    var rule = new Rule($scope.rule);
    if (rule.isValid($scope.rule)) {
      if (validation.hasIncompletePrimaryConditions($scope.rule)) {
        $scope.isSummaryVisible = true;
        $scope.summaryMessage = StrategyConstants.ERROR_MESSAGES.INCOMPLETE_PC;
        $scope.focusError();
        return;
      } else if ($scope.rule.linkCriteriaEnabled && hasIncompleteLinkConditions()) {
        $scope.isSummaryVisible = true;
        $scope.summaryMessage = StrategyConstants.ERROR_MESSAGES.INCOMPLETE_LC;
        $scope.focusError();
        return;
      } else if (hasOperandDataQuantityOverThreshold()) {
        $scope.isSummaryVisible = true;
        $scope.summaryMessage = OPERAND_DATA_OVER_THRESHOLD_ERROR_MESSAGE;
        $scope.focusError();
        return;
      } else if (!conditionsProvided()) {
        $scope.dialogMessageType = StrategyConstants.CONFIRMATION_MESSAGES.CONDITIONS_EMPTY;
        $scope.showConfirmationDialog();
        return;
      } else if ((duplicated = validation.collectDuplicatedConditions($scope.rule.primaryCriteria)) && duplicated.length) {
        $scope.isSummaryVisible = true;
        $scope.summaryMessage = StrategyConstants.ERROR_MESSAGES.PRIMARY_DUPLICATES + duplicated.join(', ');
        return;
      } else if ((duplicated = validation.collectDuplicatedConditions($scope.rule.linkCriteria)) && duplicated.length) {
        $scope.isSummaryVisible = true;
        $scope.summaryMessage = StrategyConstants.ERROR_MESSAGES.LINK_DUPLICATES + duplicated.join(', ');
        return;
      } else if (validation.isLocationAndDateSelected($scope.rule.primaryCriteria)) {
        $scope.saveRule();
        return;
      } else {
        $scope.dialogMessageType = StrategyConstants.CONFIRMATION_MESSAGES.DATE_LOCATION_EMPTY;
        $scope.showConfirmationDialog();
        return;
      }
    } else {
      if (!rule.isValidEffectiveDate($scope.rule)) {
        $scope.isSummaryVisible = true;
        $scope.summaryMessage = StrategyConstants.ERROR_MESSAGES.EFFECTIVE_DATE;
        $scope.focusError();
        return;
      }
    }
    $scope.xtForm.submit();
    if ($scope.xtForm.form.$invalid && $scope.xtForm.form.$error && !_.isEmpty($scope.xtForm.form.$error)) {
      $scope.isSummaryVisible = true;
      $scope.summaryMessage = xtFormValidationService.getSummaryMessage($scope.xtForm.form.$error);
      $scope.focusError();
    }
  };
  $scope.hideSummary = function () {
    $scope.isSummaryVisible = false;
  };
  $scope.cancelButtonHandler = function () {
    closePanel();
  };
  $scope.toggleComments = function () {
    $scope.commentsOpened = !$scope.commentsOpened;
  };
  $scope.onCommentsUpdated = function (comments) {
    $scope.commentsExist = comments.length;
  };
  $scope.onCommentsClose = function () {
    $scope.commentsOpened = false;
  };
};
RuleCustomController.$inject = ['$scope', 'ConditionsAndActionsService', 'SaveRuleService', 'StrategyConditionFactory', 'RuleFactory', 'StrategyConstants', 'ElementServiceProvider', 'CommentsService', 'UserSecureService', 'FeatureToggleService', 'CriteriaValidateAndFilterService', 'CommonUiConstants', 'XtFormValidationService'];
module.exports = RuleCustomController;